// inputLatencyProbe.ts — 「入力 → 表示の遅れ」計測フック (main 側)。
//
// 描き味ベンチ (`e2e/bench/drawingLatency.bench.ts`, docs/_wip/layer-thumbnails-
// 2026-10-13.md「描き味ベンチ」) 専用。pointerdown / pointermove を main が受けた
// 時刻 (`performance.timeOrigin + event.timeStamp` = epoch ms) を溜め、次に
// `engine.addPoints` が worker へ `stroke.points` を送るとき、その点が運ぶ入力時刻
// として添える。worker は `putImageData` まで終えた時刻 (同じく epoch ms) との差を
// 記録する。`performance.timeOrigin` は main / worker とも同じ epoch 基準なので
// 2 つの時計はそのまま引き算できる。
//
// 本番負荷: デフォルト OFF。hot path (pointermove / addPoints) に足すのは
// 「モジュール変数 boolean の読み 1 個」だけ。ON にするのは dev 限定の
// `window.__OEKAKI_PERF__.setInputLatency(true)` (main.tsx、`import.meta.env.DEV`
// ガード = production bundle には存在しない) だけ。

/** main が受けた 1 入力点。`t` は epoch ms、`first` は pen down 直後の最初の点。 */
export interface InputLatencyMark {
  readonly t: number;
  readonly first: boolean;
}

let enabled = false;
let pending: InputLatencyMark[] = [];

export const isInputLatencyEnabled = (): boolean => enabled;

export const setInputLatencyEnabled = (on: boolean): void => {
  enabled = on;
  pending = [];
};

/** pointerdown / pointermove の受信を記録する。呼び出し側で `isInputLatencyEnabled()` を確認すること。 */
export const noteInputLatencyMark = (eventTimeStamp: number, first: boolean): void => {
  pending.push({ t: performance.timeOrigin + eventTimeStamp, first });
};

/** 溜まった入力時刻を取り出して空にする (次の `stroke.points` に添える)。 */
export const takeInputLatencyMarks = (): InputLatencyMark[] => {
  const out = pending;
  pending = [];
  return out;
};
